import { IconButton as BaseIconButton } from 'shared/components/ui/icon-button';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(1.5)}`};

  &::before {
    content: '';
    position: absolute;
    right: 0;
    bottom: 100%;
    left: 0;
    height: ${({ theme }) => theme.spacing(3)};

    background: linear-gradient(
      to top,
      ${({ theme }) => theme.palette.background.paper},
      transparent
    );
    pointer-events: none;
  }
`;

export const IconButton = styled(BaseIconButton)<{ $active?: boolean }>`
  &&:hover {
    background: ${({ theme }) => theme.palette.grey[300]};
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      &&,
      &&:hover {
        background: ${theme.palette.grey[300]};
        color: ${theme.palette.text.primary};
      }
    `};
`;
